export const GET_LIST_CHECKTHONGTINKH = "GET_LIST_CHECKTHONGTINKH";
export const GET_LIST_CHECKTHONGTINKH_SUCCESS =
  "GET_LIST_CHECKTHONGTINKH_SUCCESS";
export const GET_LIST_CHECKTHONGTINKH_FAILURE =
  "GET_LIST_CHECKTHONGTINKH_FAILURE";
